/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetMetadata200ResponseDataOpengraph
 */
export interface GetMetadata200ResponseDataOpengraph {
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseDataOpengraph
   */
  locale: string
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseDataOpengraph
   */
  type: string
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseDataOpengraph
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseDataOpengraph
   */
  description: string
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseDataOpengraph
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseDataOpengraph
   */
  siteName: string
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseDataOpengraph
   */
  images?: string | null
}

/**
 * Check if a given object implements the GetMetadata200ResponseDataOpengraph interface.
 */
export function instanceOfGetMetadata200ResponseDataOpengraph(
  value: object
): value is GetMetadata200ResponseDataOpengraph {
  if (!('locale' in value) || value['locale'] === undefined) return false
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('description' in value) || value['description'] === undefined)
    return false
  if (!('url' in value) || value['url'] === undefined) return false
  if (!('siteName' in value) || value['siteName'] === undefined) return false
  return true
}

export function GetMetadata200ResponseDataOpengraphFromJSON(
  json: any
): GetMetadata200ResponseDataOpengraph {
  return GetMetadata200ResponseDataOpengraphFromJSONTyped(json, false)
}

export function GetMetadata200ResponseDataOpengraphFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetMetadata200ResponseDataOpengraph {
  if (json == null) {
    return json
  }
  return {
    locale: json['locale'],
    type: json['type'],
    title: json['title'],
    description: json['description'],
    url: json['url'],
    siteName: json['siteName'],
    images: json['images'] == null ? undefined : json['images'],
  }
}

export function GetMetadata200ResponseDataOpengraphToJSON(
  value?: GetMetadata200ResponseDataOpengraph | null
): any {
  if (value == null) {
    return value
  }
  return {
    locale: value['locale'],
    type: value['type'],
    title: value['title'],
    description: value['description'],
    url: value['url'],
    siteName: value['siteName'],
    images: value['images'],
  }
}
